import { RuleResult } from 'types/DeclarationP5'
import { CL234_PREVIOUS_DOCUMENT_EXCISE } from 'shared/ncts/common/constants'
import { removePrefix } from 'shared/ncts/common/classifier-util'
import { AdditionalReference } from '../../common/types'

const C0015Validator = {
  validateConsignmentItemAdditionalReferenceRefNumberRequirement: (additionalReference?: AdditionalReference): RuleResult => {
    if (!additionalReference) return 'OPTIONAL'

    if (CL234_PREVIOUS_DOCUMENT_EXCISE.includes(removePrefix(additionalReference.type, 'ADDITIONAL_REFERENCE_TYPE_') ?? '')) {
      return 'REQUIRED'
    }

    return 'OPTIONAL'
  },
} as const

export default C0015Validator
